import Vue from 'vue';
import AuthService from '@/services/auth.service';

export const auth = {
  namespaced: true,
  state: {
    status: {
      loggedIn: false,
    },
    app: null,
    settings: null,
  },
  actions: {
    login({ commit, dispatch }) {
      AuthService.login().then(
        app => {
          commit('loginSuccess', app);
          dispatch('getSettings');
        },
        () => {
          commit('loginFailure');
        },
      );
    },
    requestAccessToken({ commit }) {
      return AuthService.requestAccessToken().then(app => {
        commit('refreshTokenSuccess', app);
      });
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    getSettings({ commit }) {
      AuthService.getSettings().then(settings => {
        commit('setSettings', settings);
      });
    },
  },
  mutations: {
    loginSuccess(state, app) {
      localStorage.setItem('access_token', JSON.stringify(app.access_token));
      localStorage.setItem('refresh_token', JSON.stringify(app.refresh_token));
      state.status.loggedIn = true;
      Vue.set(state, 'app', app);
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      Vue.set(state, 'app', null);
    },
    refreshTokenSuccess(state, app) {
      localStorage.setItem('access_token', JSON.stringify(app.access_token));
      localStorage.setItem('refresh_token', JSON.stringify(app.refresh_token));
      Vue.set(state, 'app', app);
      state.status.loggedIn = true;
    },
    logout(state) {
      state.status.loggedIn = false;
      Vue.set(state, 'app', null);
    },
    setSettings(state, settings) {
      Vue.set(state, 'settings', settings);
    },
  },
  getters: {
    app: (state, getters) => {
      return getters.isLoggedIn ? state.app.app : {};
    },
    isLoggedIn: state => {
      return state.status.loggedIn;
    },
    settings: state => {
      return state.settings;
    },
  },
};
